import Component from '@glimmer/component';

import { sanitize } from 'webapp/utils/html';

import type ReportSlideFragment from 'webapp/models-custom/report-slide-fragment';

export interface Args {
	model: ReportSlideFragment;
}

export default class ReportsViewerFragmentTitleComponent<T extends Args> extends Component<T> {
	get text() {
		return this.args.model.primaryValue;
	}

	get sanitizedTitle(): string {
		return sanitize(this.text || '&nbsp;');
	}
	<template>
		<div class="fragment fragment--title">
			<h2 class="user-html">
				{{{this.sanitizedTitle}}}
			</h2>
		</div>
	</template>
}
